import config from 'config'
import {
  ReactivateAccount,
  ConfirmEmail,
  ConfirmLoginChange,
  ForgottenPassword,
  Logout,
  LogoutInactive,
  PasswordReset,
  Forbidden
} from 'containers/pages'

import { get } from 'lodash'
import React from 'react'
import AcceptActivity from '../containers/pages/AcceptActivity/AcceptActivity'
import RejectActivity from '../containers/pages/RejectActivity/RejectActivity'
import { OrganizationContactReactivateAccount } from '../containers/pages'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/logout`,
    component: props => (
      <Logout
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/logout-inactive`,
    component: props => (
      <LogoutInactive
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/password-reset`,
    component: props => (
      <PasswordReset
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/password-reset/success`,
    component: props => (
      <PasswordReset
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/password-reset`,
    component: props => (
      <PasswordReset
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/auth/forgotten-password`,
    component: props => (
      <ForgottenPassword
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/email-confirmations`,
    component: props => (
      <ConfirmEmail
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/account-activation`,
    component: props => (
      <ReactivateAccount
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/oc/account-activation`,
    component: props => (
      <OrganizationContactReactivateAccount
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/login-change`,
    component: props => (
      <ConfirmLoginChange
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${publicPath}/forbidden`,
    exact: true,
    component: props => (
        <Forbidden
          params={get(props, 'match.params', {})}
          {...props}
        />
    ),
    routes: []
  },
  {
    path: `${config.publicPath}/activity/accept`,
    component: props => (
      <AcceptActivity
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  },
  {
    path: `${config.publicPath}/activity/reject`,
    component: props => (
      <RejectActivity
        params={get(props, 'match.params', {})}
        {...props}
      />
    ),
    routes: []
  }
]

export default routes
